import React from 'react';
import { FramedAvatar } from '@/components/ui/FramedAvatar';
import { ClassRequestWithStudent } from '@/types/classRequests';

interface IndividualRequestCardProps {
  request: ClassRequestWithStudent;
  onAccept: (requestId: string) => void;
  onDeny: (requestId: string) => void;
  isAccepting?: boolean;
  isDenying?: boolean;
}

export const IndividualRequestCard: React.FC<IndividualRequestCardProps> = ({
  request,
  onAccept,
  onDeny,
  isAccepting = false,
  isDenying = false
}) => {
  return (
    <div className="rounded-2xl p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FramedAvatar 
            initials={request.student_name.split(' ').map((n, index) => n[0]).join('').toUpperCase()}
            size={32}
            frameSize={{ w: 40, h: 44 }}
            beltRank="blue"
            showFrame={true}
          />
          <div>
            <p className="text-white font-bold text-[12px]">
              {request.student_name}
            </p>
            <p className="text-white/60 text-[10px]">
              Templo Jiu-Jitsu Gym
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onAccept(request.request_id)}
            disabled={isAccepting}
            className="bg-[#d72e16] text-white text-[10px] font-bold px-3 py-1 rounded-full hover:bg-[#b91c1c] transition-colors disabled:opacity-50"
          >
            {isAccepting ? '...' : 'Accept'}
          </button>
          <button
            onClick={() => onDeny(request.request_id)}
            disabled={isDenying}
            className="border border-white text-white text-[10px] font-bold px-3 py-1 rounded-full hover:bg-white/10 transition-colors disabled:opacity-50"
          >
            {isDenying ? '...' : 'Deny'}
          </button>
        </div>
      </div>
    </div>
  );
};
